import { Link } from "react-router-dom";

import { Kbd } from "../components/Kbd";
import { useRepository } from "../data/api/repositories";
import { Icon } from "../icons";
import styles from "./Rail.module.css";
import { cx } from "../lib/cx";
import { paths } from "../routing/paths";
import { useRouteInfo } from "../routing/useNav";

// The rail only appears once you're inside a repository context.
export const Rail = () => {
  const route = useRouteInfo();
  // Called unconditionally (hooks rule); a null id skips the fetch when the rail
  // isn't shown.
  const { repository } = useRepository(route.repoId ?? null);

  const inRepo =
    route.repoId !== undefined &&
    (route.name === "new-agent" ||
      route.name === "repo" ||
      route.name === "repo-routines" ||
      route.name === "repo-settings" ||
      route.name === "task");
  if (!inRepo || route.repoId === undefined) {
    return null;
  }
  const repoId = route.repoId;
  // Active = the counts that still want attention (from the live repo DTO).
  const activeCount = repository
    ? repository.agents.needsInput +
      repository.agents.pending +
      repository.agents.running
    : 0;

  return (
    <aside className={cx(styles.rail, "u-hide-scrollbar")}>
      <Link
        className={cx(styles.item, route.name === "repo" && styles.active)}
        to={paths.repo(repoId)}
      >
        <span className={styles.ico}>
          <Icon.Kanban size={15} />
        </span>
        <span className={styles.label}>Tasks</span>
        <Kbd className={styles.count}>{activeCount}</Kbd>
      </Link>
      <Link
        className={cx(styles.item, route.name === "new-agent" && styles.active)}
        to={paths.newAgent(repoId)}
      >
        <span className={styles.ico}>
          <Icon.Spark size={15} />
        </span>
        <span className={styles.label}>Start an agent</span>
        <Kbd className={styles.count}>N</Kbd>
      </Link>
      <Link
        className={cx(
          styles.item,
          route.name === "repo-routines" && styles.active,
        )}
        to={paths.repoRoutines(repoId)}
      >
        <span className={styles.ico}>
          <Icon.Clock size={15} />
        </span>
        <span className={styles.label}>Routines</span>
      </Link>
      <Link
        className={cx(
          styles.item,
          route.name === "repo-settings" && styles.active,
        )}
        to={paths.repoSettings(repoId)}
      >
        <span className={styles.ico}>
          <Icon.Cog size={15} />
        </span>
        <span className={styles.label}>Repository settings</span>
      </Link>
      <div className={styles.spacer} />
    </aside>
  );
};
